import { render, staticRenderFns } from "./GP2BrowserQtlRegionPlot.vue?vue&type=template&id=75cce9bf&scoped=true&"
import script from "./GP2BrowserQtlRegionPlot.vue?vue&type=script&lang=js&"
export * from "./GP2BrowserQtlRegionPlot.vue?vue&type=script&lang=js&"
import style0 from "./GP2BrowserQtlRegionPlot.vue?vue&type=style&index=0&id=75cce9bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cce9bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75cce9bf')) {
      api.createRecord('75cce9bf', component.options)
    } else {
      api.reload('75cce9bf', component.options)
    }
    module.hot.accept("./GP2BrowserQtlRegionPlot.vue?vue&type=template&id=75cce9bf&scoped=true&", function () {
      api.rerender('75cce9bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/gp2Browser/GP2BrowserQtlRegionPlot.vue"
export default component.exports